import React from "react";
import "./MerchantDashboard.css";
import PayinChart from "./PayinChart";
import { maskValue } from "../index";
import { useSelector } from "react-redux";

function SecondSection({ payInStatistic, payoutStatistic }) {
  const showValues = useSelector((s) => s.userReducer.showValues);

  return (
    <div>
      <div className="second-section">
        <div className="settlement-wallet box-back">
          <div>
            <p className="wallet-head heading-new">Payin Breakup</p>
            <p className="sub-heading-new">
              {" "}
              ₹{" "}
              {maskValue(
                payInStatistic
                  ? payInStatistic.payinSettlementAmount
                    ? Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(payInStatistic.payinSettlementAmount)
                    : "0"
                  : "0",
                showValues

                // 
              )}
            </p>
          </div>

          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Deposit Amount:</span>
              <span className="price">
                {" "}
                ₹{" "}
                {maskValue(
                  payInStatistic
                    ? payInStatistic.payinAmount
                      ? Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(payInStatistic.payinAmount)
                      : "0"
                    : "0",
                  showValues
                )}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Commission :</span>

              <span className="price">
                {" "}
                - ₹{" "}
                {maskValue(
                  payInStatistic
                    ? payInStatistic.payinTotalComission
                      ? Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(payInStatistic.payinTotalComission)
                      : "0"
                    : "0",
                  showValues
                )}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Rolling Reserve :</span>

              <span className="price">
                {" "}
                - ₹{" "}
                {maskValue(
                  payInStatistic
                    ? payInStatistic.payinRollingReserve
                      ? Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(payInStatistic.payinRollingReserve)
                      : "0"
                    : "0",
                  showValues
                )}
              </span>
            </p>
          </div>
          {/* <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Rolling Reserve Paid:</span>

              <span className="price">
                {" "}
                + ₹{" "}
                {maskValue(
                  payInStatistic
                    ? payInStatistic.rrBalance
                      ? Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(payInStatistic.rrBalance)
                      : "0"
                    : "0",
                  showValues
                )}
              </span>

            </p>
          </div> */}
          <div className="normal-section  line-data">
            <p className="normal-font">
              <span className="">Net Payin :</span>
              <span className="price">
                {" "}
                ₹{" "}
                {maskValue(
                  payInStatistic
                    ? payInStatistic.payinSettlementAmount
                      ? Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(
                          (payInStatistic.payinAmount || 0) -
                            (payInStatistic.payinTotalComission || 0) -
                            (payInStatistic.payinRollingReserve || 0)
                        )
                      : "0"
                    : "0",
                  showValues
                )}
              </span>
            </p>
          </div>
        </div>

        <div className="chart-div settlement-wallet box-back">
          <PayinChart payInStatistic={payInStatistic} />
        </div>
      </div>
    </div>
  );
}

export default SecondSection;
